import React from 'react'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'

import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'

import ReactTable from 'react-table'
import Switch from "Components/Switch";


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      key: Utils.getRandomNumber(),
      data: [],
      columns: [],
      action: props.action,
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }


  onChangeProfil = (e, id, act) => {
    let data = this.state.data
    let pos = data.findIndex(fct => fct.option_id === id)
    data[pos].autorisation = data[pos].autorisation.replaceAt(act, e.target.checked ? '1' : '0')
    this.setState({
      data: data,
    })
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getProfil()
    }

    let columns = [
      { Header: 'id', accessor: 'option_id', show: false },
      {
        Header: 'Fonction', id: 'fonction',
        Cell: row => {
          return (
            <span className="pull-left">
                <b>{row.original.libelle + ' '}</b>
              </span>
          )
        }
      },
      {
        Header: () => <div className=""><i className="text-info ei-commun_visualiser" aria-hidden="true"></i></div>, id: 'view',
        width: 25,
        Cell: row => {
          if (row.original.defaultAutorisation[3] === 'X') {
            return (<div className=""><i className="text-danger ei-commun_fermer" aria-hidden="true"></i></div>)
          }
          return (
            <input onChange={(e) => this.onChangeProfil(e, row.original.option_id, 3)}
                   checked={row.original.autorisation !== undefined && parseInt(row.original.autorisation[3]) === 1 ? true : false
                   }
                   type="checkbox"/>
          )
        }
      },
      {
        Header: () => <div className=""><i className="text-success ei-commun_ajouter" aria-hidden="true"></i></div>,
        id: 'add',
        width: 25,
        Cell: row => {
          if (row.original.defaultAutorisation[0] === 'X') {
            return (<div className=""><i className="text-danger ei-commun_fermer" aria-hidden="true"></i></div>)
          }
          return (
            <input onChange={(e) => this.onChangeProfil(e, row.original.option_id, 0)}
                   checked={row.original.autorisation !== undefined && parseInt(row.original.autorisation[0]) === 1}
                   type="checkbox"/>
          )
        }
      },
      {
        Header: () => <div className=""><i className="text-default ei-commun_modifier" aria-hidden="true"/></div>,
        id: 'update',
        width: 25,
        Cell: row => {
          if (row.original.defaultAutorisation[2] === 'X') {
            return (<div className=""><i className="text-danger ei-commun_fermer" aria-hidden="true"/></div>)
          }
          return (
            <input onChange={(e) => this.onChangeProfil(e, row.original.option_id, 1)}
                   checked={row.original.autorisation !== undefined && parseInt(row.original.autorisation[1]) === 1}
                   type="checkbox"/>
          )
        }
      },
      {
        Header: () => <div className=""><i className="text-danger ei-commun_fermer" aria-hidden="true"/></div>,
        id: 'delete',
        width: 25,
        Cell: row => {
          if (row.original.defaultAutorisation[1] === 'X') {
            return (<div><i className="text-danger ei-commun_fermer" aria-hidden="true"/></div>)
          }
          return (
            <input onChange={(e) => this.onChangeProfil(e, row.original.option_id, 2)}
                   checked={row.original.autorisation !== undefined && parseInt(row.original.autorisation[2]) === 1}
                   type="checkbox"/>
          )
        }
      },
    ]
    let fcts = Data.list(Constants.module.COMMUN, Constants.donnee.option, {
      autorisation: {not: true, value: null}
    }).filter(option => EurestoOption(option.id))
    let datas = []
    fcts.map(fct => {
      datas.push({
        option_id: fct.id,
        libelle: fct.libelle,
        autorisation: '0000',
        defaultAutorisation: fct.autorisation
      })
    })
    const newState = {
      columns: columns,
      data: datas,
      key: Utils.getRandomNumber(),
    }
    this.setState({
      saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
      ...newState,
      key: Utils.getRandomNumber()
    }, () => this.onChangeState(this.state.data, this.props.name))
  }

  getProfil = async () => {
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'profil',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })

    console.log(result)

    let fcts = Data.list(Constants.module.COMMUN, Constants.donnee.option, {
      autorisation: {not: true, value: null}
    }).filter(option => EurestoOption(option.id))
    let datas = []
    fcts.map(fct => {
      datas.push({
        option_id: fct.id,
        libelle: fct.libelle,
        autorisation: result.results.droits.find(t => t.option_id === fct.id) && result.results.droits.find(t => t.option_id === fct.id).autorisation || '0000',
        defaultAutorisation: fct.autorisation
      })
    })

    console.log(datas)

    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        data: datas,
        type: result.results.type,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        type: result.results.type,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      droits: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'profil',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      droits: this.state.data,
      type: this.state.type,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'configuration', {
      requete: 'profil',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  onSwitch = (checked) => {
    this.setState({
      type: checked && 2 || 1
    })
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          disabled={disabled}
          name={'libelle'}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Switch onChange={this.onSwitch} name='type'
                  disabled={disabled}
                  checked={this.state.type === 2}
                  label={EurestoI18n.t('crm:Professeur ?')}/>
        <ReactTable
          className="-striped -highlight"
          data={this.state.data}
          sortable={false}
          resizable={false}
          minRows={1}
          columns={this.state.columns}
          showPagination={false}
          pageSizeOptions={[this.state.data.length]}
          defaultPageSize={this.state.data.length}
          getTheadThProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, cb) => {
                let data = this.state.data
                if (column.id === 'fonction') {
                  let checked = true
                  data.map((fct, pos) => {
                    for (let i = 0; i < data[pos].autorisation.length; i++) {
                      checked &= data[pos].autorisation[i] === '1' || data[pos].defaultAutorisation[i] === 'X'
                    }
                  })

                  data.map((fct, pos) => {
                    if (checked) {
                      data[pos].autorisation = '0000'
                    } else {
                      for (let i = 0; i < data[pos].defaultAutorisation.length; i++) {
                        if (data[pos].defaultAutorisation[i] === 'X') {
                          data[pos].autorisation = data[pos].autorisation.replaceAt(i, '0')
                        } else {
                          data[pos].autorisation = data[pos].autorisation.replaceAt(i, '1')
                        }
                      }
                    }
                  })
                } else if (column.id === 'view') {
                  let checked = true
                  data.map((fct, pos) => {
                    checked &= data[pos].autorisation[3] === '1' || data[pos].defaultAutorisation[3] === 'X'
                  })

                  data.map((fct, pos) => {
                    if (checked) {
                      data[pos].autorisation = data[pos].autorisation.replaceAt(3, '0')
                    } else {
                      if (data[pos].defaultAutorisation[3] === 'X') {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(3, '0')
                      } else {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(3, '1')
                      }
                    }
                  })
                } else if (column.id === 'add') {
                  let checked = true
                  data.map((fct, pos) => {
                    checked &= data[pos].autorisation[0] === '1' || data[pos].defaultAutorisation[0] === 'X'
                  })

                  data.map((fct, pos) => {
                    if (checked) {
                      data[pos].autorisation = data[pos].autorisation.replaceAt(0, '0')
                    } else {
                      if (data[pos].defaultAutorisation[0] === 'X') {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(0, '0')
                      } else {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(0, '1')
                      }
                    }
                  })
                } else if (column.id === 'update') {
                  let checked = true
                  data.map((fct, pos) => {
                    checked &= data[pos].autorisation[1] === '1' || data[pos].defaultAutorisation[1] === 'X'
                  })

                  data.map((fct, pos) => {
                    if (checked) {
                      data[pos].autorisation = data[pos].autorisation.replaceAt(1, '0')
                    } else {
                      if (data[pos].defaultAutorisation[1] === 'X') {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(1, '0')
                      } else {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(1, '1')
                      }
                    }
                  })
                } else if (column.id === 'delete') {
                  let checked = true
                  data.map((fct, pos) => {
                    checked &= data[pos].autorisation[2] === '1' || data[pos].defaultAutorisation[2] === 'X'
                  })

                  data.map((fct, pos) => {
                    if (checked) {
                      data[pos].autorisation = data[pos].autorisation.replaceAt(2, '0')
                    } else {
                      if (data[pos].defaultAutorisation[2] === 'X') {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(2, '0')
                      } else {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(2, '1')
                      }
                    }
                  })
                }

                this.setState({
                  data: data
                }, () => this.onChangeState(this.state.data))

              }
            }
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, cb) => {
                if (column.Header === 'Fonction') {
                  let data = this.state.data
                  let pos = data.findIndex(fct => fct.option_id === rowInfo.original.id)
                  let checked = true
                  for (let i = 0; i < data[pos].autorisation.length; i++) {
                    checked &= data[pos].autorisation[i] === '1' || data[pos].defaultAutorisation[i] === 'X'
                  }
                  if (checked) {
                    data[pos].autorisation = '0000'
                  } else {
                    for (let i = 0; i < data[pos].defaultAutorisation.length; i++) {
                      if (data[pos].defaultAutorisation[i] === 'X') {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(i, '0')
                      } else {
                        data[pos].autorisation = data[pos].autorisation.replaceAt(i, '1')
                      }
                    }
                  }
                  this.setState({
                    data: data
                  }, () => this.onChangeState(this.state.data))
                }
              }
            }
          }}
        />
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouveau profil')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Configuration/Profil.js